"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoBox = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Box = function Box(_ref) {
  var children = _ref.children,
      classes = _ref.classes;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (classes.InfoBox || '') + ' info-box'
  }, children);
};

exports["default"] = Box;
Box.propTypes = {
  "classes": _propTypes["default"].shape({
    InfoBox: _propTypes["default"].string.isRequired
  }).isRequired,
  "children": function children() {
    return (typeof _react.bpfrpt_proptype_Element === "function" ? _react.bpfrpt_proptype_Element.isRequired ? _react.bpfrpt_proptype_Element.isRequired : _react.bpfrpt_proptype_Element : _propTypes["default"].shape(_react.bpfrpt_proptype_Element).isRequired).apply(this, arguments);
  }
};
var InfoBox = (0, _ThemeProvider.withStyles)(_style["default"])(Box);
exports.InfoBox = InfoBox;
//# sourceMappingURL=InfoBox.js.map